/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react/display-name */
import React, { forwardRef, useImperativeHandle } from 'react';
import { Formik, Form, FormikProps } from 'formik';
import { Row, Col, Form as BootstrapForm } from 'react-bootstrap';
import PhoneInput from 'react-phone-input-2';
import * as yup from 'yup';
import { CountryData } from 'react-phone-input-2';
import ru from 'react-phone-input-2/lang/ru.json';

interface CustomerFormProps {
  initialValues: {
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
  };
  onSubmit: (values: any) => void;
  customerPhone: number;
  children?: React.ReactNode;
  isDisabled: boolean;
  isVisiblePhone: boolean;
}

const letters = /^[A-Za-zа-яёА-ЯЁ -]+$/i;
const regEmail = /^(([^<>()[\]\\.,;:\s@\\"]+(\.[^<>()[\]\\.,;:\s@\\"]+)*)|(\\".+\\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const schema = yup.object().shape({
  firstName: yup
    .string()
    .matches(letters, "Имя должно содержать только символы алфавита")
    .required("Заполните поле Имя")
    .min(1)
    .max(30, "Имя не может превышать 30 символов"),
  lastName: yup
    .string()
    .matches(letters, "Фамилия должна содержать только символы алфавита")
    .required("Заполните поле Фамилия")
    .min(1)
    .max(30, "Фамилия не может превышать 30 символов"),
  email: yup
    .string()
    .matches(regEmail, "Введите правильно email: you@yourdomain.com")
    .required("Заполните поле Email")
    .email("Введите правильно email: you@yourdomain.com"),
  phone: yup.string().required("Заполните поле Телефон"),
});

const style = {
  borderTopWidth: "0px",
  borderRightWidth: "0px",
  borderLeftWidth: "0px",
  borderRadius: "0px",
  fontSize: "1rem",
  width: "100%",
  "&:focus": {
    boxShadow: "0 0 0 0rem rgba(0,123,255,0.25)",
  },
};

const CustomerForm = forwardRef<FormikProps<any> | null, CustomerFormProps>(
  ({ initialValues, onSubmit, customerPhone, children, isDisabled, isVisiblePhone }, ref) => {
    return (
      <Formik
        validationSchema={schema}
        onSubmit={onSubmit}
        initialValues={initialValues}
        enableReinitialize={true}
        innerRef={ref}
      >
        {(formikProps) => {
          useImperativeHandle(ref, () => formikProps); // экспортируем методы наружу

          const { handleSubmit, handleChange, handleBlur, values, touched, errors } = formikProps;

          return (
            <Form noValidate onSubmit={handleSubmit}>
              <Row className="mb-3">
                <BootstrapForm.Group as={Col} md={12} controlId="validationFormik01" className="form-floating">
                  <BootstrapForm.Control
                    type="text"
                    name="firstName"
                    data-qa-locator="input-firstName"
                    value={values.firstName}
                    onChange={handleChange}
                    isValid={touched.firstName && !errors.firstName}
                    isInvalid={!!errors.firstName}
                    disabled={isDisabled}
                  />
                  <BootstrapForm.Label>Имя</BootstrapForm.Label>
                  <BootstrapForm.Control.Feedback type="invalid">
                    {errors.firstName?.toString()}
                  </BootstrapForm.Control.Feedback>
                </BootstrapForm.Group>
              </Row>

              <Row className="mb-3">
                <BootstrapForm.Group as={Col} md={12} controlId="validationFormik02" className="form-floating">
                  <BootstrapForm.Control
                    type="text"
                    name="lastName"
                    data-qa-locator="input-lastName"
                    value={values.lastName}
                    onChange={handleChange}
                    isValid={touched.lastName && !errors.lastName}
                    isInvalid={!!errors.lastName}
                    disabled={isDisabled}
                  />
                  <BootstrapForm.Label>Фамилия</BootstrapForm.Label>
                  <BootstrapForm.Control.Feedback type="invalid">
                    {errors.lastName?.toString()}
                  </BootstrapForm.Control.Feedback>
                </BootstrapForm.Group>
              </Row>

              <Row className="mb-3">
                <BootstrapForm.Group as={Col} md={12} controlId="validationFormik03" className="form-floating">
                  <BootstrapForm.Control
                    type="text"
                    name="email"
                    data-qa-locator="input-email"
                    value={values.email}
                    onChange={handleChange}
                    isValid={touched.email && !errors.email}
                    isInvalid={!!errors.email}
                    disabled={isDisabled}
                  />
                  <BootstrapForm.Label>Email</BootstrapForm.Label>
                  <BootstrapForm.Control.Feedback type="invalid">
                    {errors.email?.toString()}
                  </BootstrapForm.Control.Feedback>
                </BootstrapForm.Group>
              </Row>

              {customerPhone !== -1 && customerPhone?.toString().length < 9 && isVisiblePhone && (
                <Row className="mb-3">
                  <BootstrapForm.Group as={Col} md={12} controlId="validationFormik04" className="form-floating">
                    <PhoneInput
                      country={"ru"}
                      localization={ru}
                      preferredCountries={["ru", "kz", "ua"]}
                      value={values.phone}
                      inputProps={{ name: "phone" }}
                      onChange={(phoneNumber, country, e) => {
                        handleChange(e);
                      }}
                      onBlur={handleBlur}
                      inputStyle={style}
                      isValid={(inputNumber: string, country: CountryData) => {
                        const format = country.format;
                        const countNumberInPhone = [...format].filter(x => x === ".").length;
                        const phoneLength = inputNumber.length;

                        if (phoneLength !== countNumberInPhone) {
                          errors.phone = "Номер телефона заполнен не корректно.";
                        } else {
                          delete errors.phone;
                        }

                        return phoneLength === countNumberInPhone;
                      }}
                      disabled={isDisabled}
                    />
                    <BootstrapForm.Control.Feedback type="invalid">
                      Номер телефона заполнен не корректно.
                    </BootstrapForm.Control.Feedback>
                  </BootstrapForm.Group>
                </Row>
              )}
{/*               {customerPhone !== -1 && customerPhone?.toString().length < 9 && (
                <Row className="mb-3">
                  <BootstrapForm.Group as={Col} md={12} controlId="validationFormik04" className="form-floating">
                    <PhoneInput
                      country={"ru"}
                      localization={ru}
                      preferredCountries={["ru", "kz", "ua"]}
                      value={values.phone}
                      inputProps={{ name: "phone" }}
                      onChange={(phoneNumber, country, e) => {
                        handleChange(e);
                      }}
                      onBlur={handleBlur}
                      inputStyle={style}
                      isValid={(inputNumber: string, country: CountryData) => {
                        const format = country.format;
                        const countNumberInPhone = [...format].filter(x => x === ".").length;
                        const phoneLength = inputNumber.length;

                        if (phoneLength !== countNumberInPhone) {
                          errors.phone = "Номер телефона заполнен не корректно.";
                        } else {
                          delete errors.phone;
                        }

                        return phoneLength === countNumberInPhone;
                      }}
                      disabled={isDisabled}
                    />
                    <BootstrapForm.Control.Feedback type="invalid">
                      Номер телефона заполнен не корректно.
                    </BootstrapForm.Control.Feedback>
                  </BootstrapForm.Group>
                </Row>
              )} */}
              {children}
            </Form>
          );
        }}
      </Formik>
    );
  }
);

export default CustomerForm;
